import React from "react";
import Movie from "../components/Movie/Movie";
import Navbar from "../components/Navbar/Navbar";
import "./FilterByTitle.css";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Spinner from "react-bootstrap/Spinner";

function FilterByTitle() {
  const [movies, setMovies] = React.useState([]);
  const [hasMore, setHasMore] = React.useState(true);
  const [page, setCurrentPage] = React.useState(1);
  const [title, setTitle] = React.useState("");
  const [titleIsChanged, setTitleIsChanged] = React.useState(false);
  const [fetching, setFetching] = React.useState(false);

  React.useEffect(() => {
    const getMovies = async () => {
      setFetching(true);
      const response = await axios({
        method: "GET",
        url: `https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_API_KEY}`,
        params: {
          include_adult: false,
          query: title,
          page: page,
        },
      });

      page > 1
        ? setMovies([...movies, ...response.data.results])
        : setMovies(response.data.results);

      if (titleIsChanged && page === 1) setMovies(response.data.results);

      response.data.results.length === 0 || response.data.results.length < 20
        ? setHasMore(false)
        : setHasMore(true);

      setFetching(false);
    };

    title ? getMovies().catch(alert) : setMovies([]);
  }, [title, page]);

  const handleScroll = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const createUniqueId = () => {
    const unique_id = uuid();
    return unique_id;
  };

  const handleTitle = (ev) => {
    setTitle(ev.target.value);
    setTitleIsChanged(true);
    setCurrentPage(1);
  };

  return (
    <>
      <Navbar />
      <div className="container">
        <form className="mb-5">
          <label htmlFor="title" className="visually-hidden"></label>
          <input
            id="search"
            type="text"
            className="bg-dark"
            placeholder="Title..."
            value={title}
            onChange={(ev) => handleTitle(ev)}
          />
        </form>

        {fetching && (
          <Spinner animation="border" role="status" variant="light">
            <span className="visually-hidden ">Loading...</span>
          </Spinner>
        )}
        {title === "" && <p>Nothing to search</p>}
        {title !== "" && movies.length === 0 && !fetching && (
          <p>Not results found</p>
        )}
        {title !== "" && movies.length > 0 && (
          <>
            <h3 className="text-start">Movies</h3>
            <hr className="mt-3" />
          </>
        )}

        <InfiniteScroll
          dataLength={movies.length}
          next={handleScroll}
          hasMore={hasMore}
          style={{ overflow: "hidden" }}
        >
          <div className="row mt-5">
            {movies.map((movie) => (
              <Movie key={createUniqueId()} movie={movie} />
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </>
  );
}

export default FilterByTitle;
